import { makeInputPattern } from 'shared/ui/TextField/Input/InputPattern'

export const InputPhone = makeInputPattern({
  format: '(###) ###-####',
  placeholder: '(123) 123-1234',
})
